<template>
  <select class="form-control form-control-sm" placeholder="Select column" @change="change">
    <option value="" :selected="!selected">---</option>
    <option v-for="(option, i) in options" :value="option" :key="i" :selected="option === selected">
      {{ getOptionTitle(option) }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'EmployeeColumnSelect',
  props: {
    num: {
      type: Number,
      required: true,
      default: 0
    },
    columnsBinding: {
      type: Object,
      required: true
    }
  },
  computed: {
    options() {
      return Object.keys(this.columnsBinding).map((fieldName) => fieldName)
    },
    selected() {
      let selected = null
      Object.keys(this.columnsBinding).forEach((fieldName) => {
        if (this.columnsBinding[fieldName] === this.num) {
          selected = fieldName
        }
      })
      return selected
    }
  },
  methods: {
    getOptionTitle(option) {
      return option
        .split('_')
        .map((word) => `${word[0].toUpperCase()}${word.slice(1)}`)
        .join(' ')
    },
    change(e) {
      if (e instanceof Event) {
        this.$emit('change', { fieldName: e.target.value, num: this.num })
      }
    }
  }
}
</script>

<style scoped></style>
